import SEO from "../../SEO";
import ProjectHero from "./ProjectHero";
import SectionRenderer from "./SectionRenderer";

// A whole case study page: hero plus whatever sections the content JSON lists.
export default function CaseStudyLayout(props: { caseStudy: CaseStudyT; url?: string }) {
  const { caseStudy, url } = props;
  const { project_Name, helmet_Description, hero, sections } = caseStudy;

  return (
    <div className="page-content fade-in case-study">
      <SEO
        title={project_Name}
        description={helmet_Description || hero.description || ""}
        image={hero.image_Url}
        url={url}
      />
      <ProjectHero hero={hero} />
      {sections.map((section, index) => (
        <SectionRenderer key={`${section.variant}_${index}`} section={section} />
      ))}
    </div>
  );
}
